// extracted by mini-css-extract-plugin
export default {"addStockButton":"style_addStockButton__INmNu"};